Array.prototype.removeIndexedItem = function (index) {
  return [...this.slice(0, index), ...this.slice(index + 1)];
};

export function setNestedValue(obj, path, value) {
  var schema = obj;
  var pList = path.split('.');
  var len = pList.length;
  for (var i = 0; i < len - 1; i++) {
    var elem = pList[i];
    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }

  schema[pList[len - 1]] = value;
  return obj;
}

export function setSessionStorage(key, val) {
  sessionStorage.setItem(key, val);
}

export function getSessionStorage(key) {
  return sessionStorage.getItem(key);
}

/** True when session value is present and not the string "null"/"undefined" (bad writes). */
export function isSessionValueReady(val) {
  if (val == null) return false;
  const s = String(val).trim();
  return s !== '' && s !== 'null' && s !== 'undefined';
}

export function fileToByteArray(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onloadend = (evt) => {
      if (evt.target.readyState === FileReader.DONE) {
        const array = new Uint8Array(evt.target.result);
        const hexArray = toHexString(array);
        resolve(hexArray);
      } else {
        reject(new Error('FileReader operation failed'));
      }
    };

    reader.onerror = reject;

    reader.readAsArrayBuffer(file);
  });
}

function toHexString(byteArray) {
  return Array.from(byteArray, function (byte) {
    return ('0' + (byte & 0xff).toString(16)).slice(-2);
  }).join('');
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result.split(',')[1]);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}
export const isValidEmail = (email) => {
  return /^[^\s@]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

export const handleSearch = (text, rows, columns) => {
  if (text.length) {
    const newRows = rows.filter((row) => {
      for (let i = 0; i < columns.length; i++) {
        const col = columns[i];
        if (col.field) {
          let rowVal;
          if (col.valueGetter) {
            const got = col.valueGetter(row[col.field], row, col);
            rowVal = got != null && got !== '' ? String(got).toLowerCase() : '';
          } else if (col.field !== 'actions' && col.renderCell) {
            const element = col.renderCell({ row });
            if (element?.props?.children?.length) {
              rowVal = element?.props?.children?.join('').toLowerCase();
            }
          } else {
            rowVal = row[col.field]?.toString().toLowerCase();
          }

          if (rowVal && rowVal.indexOf(text.toLowerCase()) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
    return newRows || [];
  }
};
